














































































































































































































































import {Emit, Prop, Vue, Component, Watch} from 'vue-property-decorator';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import Datepicker from '@/components/datepicker/DatePicker.vue';
import AmountField from '@/components/atom/input/AmountField.vue';
import TextField from '@/components/atom/input/TextField.vue';
import TextField10 from '@/components/atom/input/TextField10.vue';
import TextField15 from '@/components/atom/input/TextField15.vue';
import SlipLineNoField from '@/components/atom/input/SlipLineNoField.vue';
import ToggleButtonField from '@/views/stock/StockToggleButtonField.vue';
import {progress} from '@/script/progress';
import moment from 'moment';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import WholesaleSelector from '@/components/wholesale/WholesaleSelector.vue';
import api from '@/infrastructure/api/api';
import {loginModule} from '@/store/authentication/login';
import CompleteDialog from '@/components/atom/dialog/CompleteDialog.vue';
import {
  入庫候補発注検索条件型,
  入庫候補発注補検索結果レコード型,
  オプション区分型,
  商品区分一覧,
  検索並び順区分一覧,
  発注ステータス区分一覧,
  入庫候補発注検索条件Validator,
  発注指定入庫入力型,
  発注指定入庫確定依頼型,
  入庫候補発注検索結果型,
  入庫情報タブ入力型,
  入庫情報全指定バリデータマップ一覧,
} from '@/type/stock/receive/order';
import {マスタ選択区分型} from '@/type/wholesale/types';
import {ValidationResult} from '@/type/validation/result';
import 発注指定入庫入力チェッカー from '@/type/stock/receive/発注指定入庫入力チェッカー';
@Component({
  components: {
    Datepicker,
    ButtonPanel,
    IconButton,
    NormalDialog,
    NormalButton,
    ConfirmDialog,
    AmountField,
    TextField,
    TextField10,
    TextField15,
    SlipLineNoField,
    ToggleButtonField,
    AlertDialog,
    WholesaleSelector,
    CompleteDialog,
  },
})
export default class RegisterReceiveByOrderDialog extends Vue {
  // data
  検索条件: 入庫候補発注検索条件型 = this.デフォルトの検索条件();
  検索結果: 入庫候補発注補検索結果レコード型[] = [];
  入庫情報タブ入力: 入庫情報タブ入力型 = this.入庫情報タブ入力初期値();

  選択行番号: number | null = null;

  卸伝票合計金額: number | null = null;

  検索条件バリデーション結果: ValidationResult = new ValidationResult(入庫候補発注検索条件Validator);
  checker: 発注指定入庫入力チェッカー = new 発注指定入庫入力チェッカー();

  // props
  @Prop({required: true})
  departmentCode!: string;

  @Emit('close')
  閉じる() {
    this.clear();
    this.$modal.hide('RegisterReceiveByOrderDialog');
  }

  get 表示件数(): number {
    return this.検索結果.length;
  }

  get 商品区分一覧(): オプション区分型[] {
    return 商品区分一覧;
  }

  get 並び順一覧(): オプション区分型[] {
    return 検索並び順区分一覧;
  }

  get 発注ステータス一覧(): オプション区分型[] {
    return 発注ステータス区分一覧;
  }

  デフォルトの検索条件(): 入庫候補発注検索条件型 {
    return {
      商品区分: null,
      並び順区分: '発注伝票番号',
      卸コード: null,
      メーカー名: null,
      商品名カナ: null,
      発注日FROM: null,
      発注日TO: null,
      発注伝票番号FROM: null,
      発注伝票番号TO: null,
      納品指定日FROM: null,
      納品指定日TO: null,
      発注ステータス区分: null,
    };
  }

  絞込条件入力エラー判定(項目名: string): boolean {
    return this.検索条件バリデーション結果.hasError(項目名);
  }

  入力エラー判定(行番号: number, 項目名: string): boolean {
    return this.checker.hasError(項目名, 行番号);
  }


  async 検索確認する(): Promise<void> {
    if (this.検索条件バリデーション結果.hasErrors) {
      this.$emit('show-alert', this.検索条件バリデーション結果.getMessages());
      return;
    }

    if (this.検索結果.some((it) => it.選択)) {
      this.$modal.show('選択中確認ダイアログ');
      return;
    }
    await progress(this.検索する);
  }

  async 確認後の検索するハンドラ() {
    this.$modal.hide('選択中確認ダイアログ');
    await progress(this.検索する);
  }


  選択中確認ダイアログを閉じる(): void {
    this.$modal.hide('選択中確認ダイアログ');
  }

  async 検索する() {
    await api.入庫候補発注を検索する(this.検索条件)
            .then((response: 入庫候補発注検索結果型) => {
              this.検索結果 = response.入庫候補発注検索結果レコード一覧;
              this.選択行番号 = null;
              this.卸伝票合計金額 = null;
              if (this.検索結果.length === 0) {
                this.$emit('show-alert', '検索結果が0件です。');
                return;
              }
              for (const レコード of this.検索結果) {
                レコード.入庫数 = レコード.入庫残数;
              }
              if (response.アラートメッセージ) {
                this.$emit('show-alert', response.アラートメッセージ);
              }
            })
            .catch((error: any) => {
              this.$emit('show-alert', error.data.message);
            });
  }

  async 全指定(): Promise<void> {
    if ((!this.入庫情報タブ入力.入庫伝票日付) && (!this.入庫情報タブ入力.入庫伝票番号)) {
      return;
    }
    const 入庫情報全指定バリデーション結果: ValidationResult = new ValidationResult(入庫情報全指定バリデータマップ一覧);
    入庫情報全指定バリデーション結果.validate(this.入庫情報タブ入力);
    if (入庫情報全指定バリデーション結果.hasErrors) {
      this.$emit('show-alert', 入庫情報全指定バリデーション結果.getMessages());
      return;
    }

    this.検索結果 = this.検索結果.map((レコード) => {
      if (レコード.選択) {
        レコード.入庫日付 = this.入庫情報タブ入力.入庫伝票日付 ? this.入庫情報タブ入力.入庫伝票日付 : レコード.入庫日付;
        レコード.卸伝票番号 = this.入庫情報タブ入力.入庫伝票番号 ? this.入庫情報タブ入力.入庫伝票番号 : レコード.卸伝票番号;
      }
      return レコード;
    });
  }

  async 合計計算(): Promise<void> {
    this.卸伝票合計金額 = null;
    if (this.選択行番号 === null || !this.検索結果[this.選択行番号].卸伝票番号) {
      return;
    }
    let 合計金額: number = 0;
    this.検索結果.map((レコード) => {
      if (this.選択行番号 !== null && レコード.卸伝票番号 === this.検索結果[this.選択行番号].卸伝票番号) {
        合計金額 += レコード.入庫単価 * レコード.入庫数;
      }
    });
    this.卸伝票合計金額 = 合計金額;
  }

  async 確定する() {
    const 選択済入庫候補一覧 = this.検索結果.filter((選択済入庫候補: 入庫候補発注補検索結果レコード型) => 選択済入庫候補.選択);
    if (選択済入庫候補一覧.length < 1) {
      this.$emit('show-alert', '確定対象が存在しません');
      return;
    }

    if (this.checker.hasErrors()) {
      this.$emit('show-alert', this.checker.errorMessages());
      return;
    }

    const 発注指定入庫入力一覧 = this.入力リクエスト形式に変換する(選択済入庫候補一覧);

    const 発注指定入庫確定依頼 = {
      入庫先部署: this.departmentCode,
      入庫入力一覧: 発注指定入庫入力一覧,
    };

    await api.発注指定入庫を確定する(発注指定入庫確定依頼)
      .then((response: any) => {
        this.$modal.show('発注指定入庫登録完了ダイアログ');
      })
      .catch((error: any) => {
        const アラートメッセージ: string[] = this.APIアラートメッセージを取得(error.data);
        this.$emit('show-alert', アラートメッセージ);
      });

    return;
  }

  行が選択されている(行番号: number): boolean {
    if (this.選択行番号 === null) return false;
    return this.選択行番号 === 行番号;
  }

  行を選択する(行番号: number): void {
    this.選択行番号 = 行番号;
  }

  全解除する(): void {
    for (const レコード of this.検索結果) {
      レコード.選択 = false;
    }
    this.$forceUpdate();
  }

  全選択する(): void {
    for (const レコード of this.検索結果) {
      レコード.選択 = true;
    }
    this.$forceUpdate();
  }

  入力リクエスト形式に変換する(レコード一覧: 入庫候補発注補検索結果レコード型[]): 発注指定入庫入力型[] {
    return レコード一覧.map((レコード: 入庫候補発注補検索結果レコード型) => {
      return {
        商品区分: レコード.商品区分,
        メーカー名: レコード.メーカー名,
        商品名: レコード.商品名,
        規格容量: レコード.規格容量,
        卸コード: レコード.卸コード,
        卸名: レコード.卸名,
        発注日: レコード.発注日,
        発注伝票番号: レコード.発注伝票番号,
        発注伝票行番号: レコード.発注伝票行番号,
        入庫日付: レコード.入庫日付,
        入力単価: レコード.入庫単価,
        入庫数: レコード.入庫数,
        入庫遡及対象外区分: レコード.入庫遡及対象外区分,
        有効期限: レコード.有効期限,
        ロット番号: レコード.ロット番号,
        伝票番号: レコード.卸伝票番号,
        伝票行番号: レコード.卸伝票行番号,
        納品指定日: レコード.納品指定日,
        発注数: レコード.発注数,
        入庫残数: レコード.入庫残数,
        発注ステータス区分: レコード.発注ステータス区分,
        発注更新バージョン: レコード.発注更新バージョン,
        変更前有効期限: レコード.変更前有効期限,
        有効期限入力フラグ: レコード.有効期限入力フラグ,
      };
    });
  }

入庫情報タブ入力初期値(): 入庫情報タブ入力型 {
  return {
    入庫伝票番号: '',
    入庫伝票日付: null,
  };
}

APIアラートメッセージを取得(data: any): string[] {
  let メッセージ = [data.message];
  if (!data.errors) {
    return メッセージ;
  }

  for (const エラー of data.errors) {
    メッセージ = メッセージ.concat(['・' + エラー]);
  }
  return メッセージ;
}

  beforeUpdate(): void {
    // データ更新時にバリデート処理
    this.検索条件バリデーション結果.validate(this.検索条件);
    this.checker.validateList(this.検索結果);
  }

  async beforeOpen() {
    return;
  }

  clear(): void {
    this.検索条件 = this.デフォルトの検索条件();
    this.検索結果 = [];
    this.入庫情報タブ入力 = this.入庫情報タブ入力初期値();
  }

  private mounted() {
    this.clear();
  }

}
